import { observer } from 'mobx-react';
import React from 'react';
import { useI18n } from '@udemy/i18n';
import { useHeaderStore } from '../../hooks/use-header-store';
import { useMyLearningStore } from '../../hooks/use-my-learning-store';
import { HeaderDropdown, HeaderButton, HeaderMenu } from '../header-dropdown.react-component';
import { MyLearningItems } from './my-learning-items.react-component';
export const MyLearningDropdown = observer(({
  className = ''
}) => {
  const headerStore = useHeaderStore();
  const myLearningStore = useMyLearningStore();
  const {
    gettext
  } = useI18n();
  return /*#__PURE__*/React.createElement(HeaderDropdown, {
    trigger: /*#__PURE__*/React.createElement(HeaderButton, {
      componentClass: "a",
      href: headerStore.urls.MY_LEARNING,
      "data-testid": "my-courses"
    }, gettext('My learning')),
    className: className,
    onFirstOpen: myLearningStore.loadMyLearningContent
  }, /*#__PURE__*/React.createElement(HeaderMenu, null, /*#__PURE__*/React.createElement(MyLearningItems, null)));
});
//# sourceMappingURL=my-learning-dropdown.react-component.js.map